module.exports = __webpack_public_path__ + "media/images/countryrect/bg-8b6292933f89fb36b73655c46e2922b4.svg";